<template>
  <v-row v-if="ownClassTeacher && ownClassTeacher.id">
    <v-col cols="3">
      <h2 class="primary--text">{{ ownClassTeacher | _get('name') }}</h2>
      <p class="grey--text">{{ ownClassTeacher | _get('code') }}</p>
    </v-col>
    <v-col cols="2">
      <span class="grey--text">Lĩnh vực</span>
      <p>{{ getSubjectGroupName(ownClassTeacher.subjectGroup) }}</p>
    </v-col>
    <v-col cols="2">
      <span class="grey--text">Loại cán bộ</span>
      <p>{{ ownClassTeacher | _get('type') | teacherType }}</p>
    </v-col>
    <v-col cols="2">
      <span class="grey--text">Số điện thoại</span>
      <p>{{ ownClassTeacher | _get('phone') }}</p>
    </v-col>
    <v-col cols="3">
      <span class="grey--text">Email</span>
      <p>{{ ownClassTeacher | _get('email') }}</p>
    </v-col>
  </v-row>
  <div v-else>
    <h3>Chưa có giáo viên</h3>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {}
  },
  props: {
    ownClassTeacher: Object
  },
  computed: {
    ...mapState('classDetail', ['subjectGroups'])
  },
  methods: {
    getSubjectGroupName(id) {
      const subjectGroup = this.subjectGroups.find(s => s.id === id)
      return subjectGroup.title || 'Không có'
    }
  },
  filters: {}
}
</script>
